export const GET_ALL_POLICIES_AUTH = 'GET_ALL_POLICIES_AUTH';
export const GET_ALL_POLICIES_AUTH_LOADING = 'GET_ALL_POLICIES_AUTH_LOADING';
export const SET_AUTH_POLICIES_COUNT = 'SET_AUTH_POLICIES_COUNT';
export const ADD_RULE = 'ADD_RULE';
export const ADD_MAIN_RULE = 'ADD_MAIN_RULE';
export const REMOVE_RULE = 'REMOVE_RULE';
export const RESET_RULES = 'RESET_RULES';
export const ADD_RULE_ELEMENT = 'ADD_RULE_ELEMENT';
export const ADD_MAIN_RULE_ELEMENT = 'ADD_MAIN_RULE_ELEMENT';
export const UPDATE_RULE_ELEMENT = 'UPDATE_RULE_ELEMENT';
export const UPDATE_MAIN_RULE_ELEMENT = 'UPDATE_MAIN_RULE_ELEMENT';
export const REMOVE_RULE_ELEMENT = 'REMOVE_RULE_ELEMENT';
export const REMOVE_MAIN_RULE_ELEMENT = 'REMOVE_MAIN_RULE_ELEMENT';
export const SET_RULE_OPERATOR = 'SET_RULE_OPERATOR';
export const SET_MAIN_RULE_OPERATOR = 'SET_MAIN_RULE_OPERATOR';
